import type { Action } from 'state/actions';
import * as dynamicActionTypes from 'state/dynamic/dynamicForm.actionTypes';
import { addKey, addOrPatchKey, patchKeyIfExist, removeKey, removeKeys } from 'state/utils/collection';

import { mapFromCommitModeToQuoteType } from '../results/result.model';
import type { BookingType, QuoteInfos, QuoteInfosMap } from './infos.model';

export function infosReducer(state: QuoteInfosMap = {}, action: Action): QuoteInfosMap {
  switch (action.type) {
    case 'QUOTE_ACKED':
    case 'STREAMING_QUOTE_ACKED':
      return addKey(state, action.quoteId, {
        workspace: action.workspace,
        quoteType: action.quoteType,
        lastUpdated: action.when,
      } as QuoteInfos);
    case 'QUOTE_RECEIVED':
    case 'TRADE_AUTH_RECEIVED':
    case 'QUOTE_TRADE_DONE':
    case 'QUOTE_RESULT_FAILED':
    case 'QUOTE_TRADE_REJECTED':
    case 'STREAMING_TRADE_AUTH_RECEIVED':
    case 'QUOTE_STREAMING_TRADE_DONE':
      return patchKeyIfExist(state, action.quoteId, () => ({ lastUpdated: action.when }));
    case dynamicActionTypes.DYNAMIC_BOOKING_REQUESTED:
      return addOrPatchKey(state, action.quoteId, () => ({
        bookingType: (action.withExecution ? 'BookWithExecution' : 'BookWithoutExecution') as BookingType,
      }));
    case dynamicActionTypes.DYNAMIC_BOOKING_QUOTE_FAILED:
      return removeKey(state, action.quoteId);
    case 'PREVIOUS_QUOTE_LOAD_REQUESTED':
      return addOrPatchKey(
        state,
        action.quoteId,
        () => ({ workspace: action.workspace, isLoadingPrevious: true }) as QuoteInfos,
      );
    case 'PREVIOUS_QUOTE_LOADED':
    case 'BATCH_PREVIOUS_QUOTE_LOADED':
      return addOrPatchKey(
        state,
        action.quoteId,
        () =>
          ({
            isLoadingPrevious: false,
            quoteType: mapFromCommitModeToQuoteType(action.quote.commitMode),
          }) as QuoteInfos,
      );
    case 'PREVIOUS_QUOTE_LOADING_FAILED':
      return addOrPatchKey(state, action.quoteId, () => ({ isLoadingPrevious: false }) as QuoteInfos);

    case 'QUOTES_REMOVED':
      return removeKeys(state, action.quoteIds);
    default:
      return state;
  }
}
